export default (b) => {
  return b ? 'activo' : 'inactivo'
}
